import { render, staticRenderFns } from "./review-document-modal.vue?vue&type=template&id=232b9e01&"
import script from "./review-document-modal.vue?vue&type=script&lang=js&"
export * from "./review-document-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports